import {HttpParams} from '@angular/common/http';

/**
 * Строит `HttpParams` из произвольного объекта: пропускает `null`/`undefined`,
 * остальные значения добавляет как `append(key, String(value))`.
 *
 * Дженерик-хелпер «объект → query-string». Сервисы, которые собирают КОНКРЕТНЫЕ
 * именованные параметры со своей логикой (page/size/условные set), это не заменяет —
 * только массовую сборку из словаря фильтров.
 */
export function buildQueryParams(source: Record<string, unknown>): HttpParams {
  let params = new HttpParams();
  Object.keys(source).forEach(key => {
    const value = source[key];
    if (value !== undefined && value !== null) {
      params = params.append(key, String(value));
    }
  });
  return params;
}
